import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import SearchIcon from "@mui/icons-material/Search";
import {
  Badge,
  Box,
  ButtonGroup,
  Checkbox,
  debounce,
  Grid2,
  List,
  ListItem,
  MenuItem,
  TableCell,
  Typography,
} from "@mui/material";
import { Gauge, gaugeClasses } from "@mui/x-charts";
import React, {
  Fragment,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteIco from "../../assets/icons/DeleteIco";
import EyeIco from "../../assets/icons/EyeIco";
import FileAddIco from "../../assets/icons/FileAddIco";
import ShareIco from "../../assets/icons/ShareIco";
import StatusChangeIco from "../../assets/icons/StatusChangeIco";
import CommonButton from "../../component/Button";
import CommonTextField from "../../component/Input";
import CustomMenuItem from "../../component/Menu";
import DropDownSelect from "../../component/Select";
import SnackBar from "../../component/SnackBar";
import {
  AddToJobPool,
  AddToJobPoolBuffer,
  AddToJobPoolList,
  CandidateDelete,
  CandidateMultiEmail,
  CandidateStatusChange,
  ResumeShare,
  SearchAndListOfResumes,
} from "../../redux/action/Candidate";
import { CandidateFilter } from "../../redux/action/Candidate";
import { CustomDiv } from "../chat-bot/style";
import SkillDeleteDialog from "../common-components/DeleteDialog";
import FilterDialog from "../common-components/FilterDialog";
import {
  CheckBoxSelected,
  CommonGrid2,
  CustomTooltip,
  DotColor,
  ScoreChange,
  StyledFlexRowView,
} from "../common-components/StyledComponents";
import DialogCandidateHub from "../jobs/jobs-candidate/components/DialogCandidateHub";
import { CustomizeChip, CustomizeSpan } from "../jobs/style";
import ShareQuickMatch from "../matches/quick-match/components/ShareQuickMatch";
import AddJobPool from "./AddJobPool";
import CommonTable from "./Table";
import { SendInterest } from "../../redux/action/CoverSheet";
import { checkBackGroundProcess } from "../../redux/action/Job";

export default function Candidates() {
  const [filterPopup, setFilterPopup] = useState(false);
  const [titleValue, setTitleValue] = useState("");
  const [filterList, setFilterList] = useState([]);
  const [openActiveJobDialog, setOpenActiveJobDialog] = useState(false);
  const [debouncedQuery, setDebouncedQuery] = useState("");
  const [suggestion, setSuggestion] = useState([]);
  const [correctedQuery, setCorrectedQuery] = useState("");
  const [currentQuery, setCurrentQuery] = useState(false);
  const [showSuggestion, setShowSuggestion] = useState(false);
  const limit = 10;
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const URL = process.env.REACT_APP_URL;
  const open = Boolean(anchorEl);
  const [tableRowData, setTableRowData] = useState({});
  const navigate = useNavigate();
  const suggestionsRef = useRef(null);
  const [jobTitles, setJobTitles] = React.useState([]);
  const [selectedJobTitle, setSelectedJobTitle] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState({ file: [] });
  const [isRunning, setIsRunning] = useState(false);
  const [buttonLoading, setButtonLoading] = useState({
    disabled: false,
    loading: false,
  });
  const addToJobPoolData = useSelector((state) => state.candidate.addToJobPool);
  const url = process.env.REACT_APP_URL;
  const localStorageData = JSON.parse(localStorage.getItem("credential"));
  const [statusDialog, setStatusDialog] = useState({
    open: false,
    disabled: false,
    noLoading: false,
    yesLoading: false,
    value: "",
    id: "",
  });
  const [checkInterestStatusDialog, setCheckInterestStatusDialog] = useState({
    open: false,
    disabled: false,
    noLoading: false,
    yesLoading: false,
  });

  const [selectDialog, setSelectDialog] = useState({
    open: false,
    disabled: false,
    changeStatusLoading: false,
    cancelLoading: false,
    changeLoading: false,
    value: "Active",
    id: "",
    condition: true,
  });
  const [shareDialogOpen, setShareDialogOpen] = useState({
    open: false,
    loading: false,
    multiEmail: false,
  });
  const query = new URLSearchParams(useLocation().search);
  const [deleteDialog, setDeleteDialog] = useState({
    open: false,
    loading: false,
    content: "",
  });
  const [snackbarState, setSnackbarState] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [candidateList, setCandidateList] = useState({
    data: [],
    currentPage: 1,
    totalPage: "",
    loading: true,
    count: "",
    direction: "desc",
    columnName: "",
    columnkey: "updated_at",
    status: true,
  });

  const [checkSelected, setCheckSelected] = useState({
    count: 0,
    selected: [],
  });
  const [backGroundprocess, setBackGroundprocess] = useState({
  open: false,
  openLoading: false,
  buttonLoading: false,
});

  const [headerData, setHeaderData] = useState([
    {
      name: "ID",
      direction: "desc",
      defaultDirection: "desc",
      sort: true,
      active: false,
      width: "6%",
      key: "order_no",
    },
    {
      name: "Name",
      direction: "asc",
      defaultDirection: "asc",
      sort: true,
      active: false,
      width: "16%",
      key: "personal_details.candidate_name.keyword",
    },
    {
      name: "Title",
      direction: "asc",
      defaultDirection: "asc",
      sort: true,
      active: false,
      width: "30%",
      key: "personal_details.title.keyword",
    },
    {
      name: "Status",
      direction: "asc",
      defaultDirection: "asc",
      sort: false,
      width: "10%",
    },
    {
      name: "Score",
      direction: "asc",
      defaultDirection: "asc",
      sort: false,
      width: "14%",
    },
    {
      name: "Last Activity",
      direction: "desc",
      defaultDirection: "desc",
      sort: true,
      active: true,
      width: "15%",
      key: "updated_at",
    },
    { width: "5%" },
  ]);
  const filterOptions = [
    {
      label: "Location",
      key: "location",
      type: "multi-select",
      options: filterList.location,
    },
    {
      label: "Domain",
      key: "domain",
      type: "multi-select",
      options: filterList.domain,
    },
    {
      label: "Seniority Level",
      key: "seniority",
      type: "multi-select",
      options: filterList.seniority,
    },
    { label: "Date Range", key: "dateRange", type: "date" },
    {
      label: "Education",
      key: "education",
      type: "multi-select",
      options: filterList.education,
    },
    {
      label: "Status",
      key: "status",
      type: "multi-select",
      options: filterList.status,
    },
  ];

 const previousPathName = useSelector((state) => state.layout.pathName);
const isReturningFromView =previousPathName?.pathname?.includes("/candidate-view");

const [filterState, setFilterState] = useState(() => {
  const base = filterOptions.reduce((acc, option) => {
    acc[option.key] = option.type === "multi-select" ? [] : option.value || null;
    return acc;
  }, {});

  // Only apply default Active filter on a true fresh load
  if (!isReturningFromView) {
    base.status = ["Active"];
  }

  return base;
});
  const activeJobData = [
    {
      options: jobTitles,
      onChange: (value) => setSelectedJobTitle(value),
      placeholder: "Choose a job",
    },
  ];

  const candidateFilter = useSelector(
    (state) => state.candidate.candidateFilter,
  );
 

  const fetchCandidatesList = async ({
    limit = 10,
    offset = (candidateList.currentPage - 1) * limit,
    q = debouncedQuery,
    filterValues = filterState,
    status_flag = false,
    is_generative = false,
    columnkey = candidateList.columnkey || "updated_at",
    direction = candidateList.direction || "desc",
    status = candidateList.status || true,
  }) => {
    setCandidateList((prev) => ({
      ...prev,
      loading: true,
    }));

    try {
      const filters = [
        {
          field: "personal_details.location.keyword",
          value: filterValues.location || "",
        },
        {
          field: "personal_details.industry.keyword",
          value: filterValues.domain || "",
        },
        {
          field: "personal_details.seniority_level.keyword",
          value: filterValues.seniority || "",
        },
        {
          field: "updated_at",
          from_date: filterValues.dateRange?.from_date || "",
          to_date: filterValues.dateRange?.to_date || "",
        },
        {
          field: "elc_table.qualifications.name.keyword",
          value: filterValues.education || "",
        },
        {
          field: "status.keyword",
          value: filterValues["status"] || "",
        },
      ].filter((filter) => Object.values(filter).some((value) => value !== ""));

      let params = {
        limit: limit,
        offset: offset,
      };
      let payload = {
        q,
        filter: filters,
        status_flag: status_flag,
        sort: {
          order: direction,
          status: status,
          field: columnkey,
        },
        organization_id: JSON.parse(localStorage.getItem("credential"))
          ?.organization_id,
        is_generative: is_generative,
      };
      const response = await SearchAndListOfResumes(payload, params);

      setCandidateList((prev) => ({
        ...prev,
        data: response?.data?.results || [],
        totalPage: response?.data?.total_pages,
        loading: false,
        count: response?.data?.count || "",
      }));
      setFilterList(response?.data?.filters);
      setSuggestion(response?.data?.suggestions);
      setCorrectedQuery(response?.data?.corrected_query);
      setCurrentQuery(response?.data?.current_query);
    } catch (error) {
      setSnackbarState({
        open: true,
        severity: "error",
        message: error.message,
      });
      setCandidateList((prev) => ({
        ...prev,
        data: [],
        totalPage: 0,
        loading: false,
        count: 0,
      }));

      setFilterList([]);
      setSuggestion([]);
    }
  };

  const handleCloseValidation = () => {
    setSnackbarState((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleSearchChange = useCallback(
    debounce((q) => {
      fetchCandidatesList({
        limit,
        offset: 0,
        q: q,
        filterValues: filterState,
        status_flag: false,
        is_generative: q ? true : false,
      });
    }, 500),
    [filterState],
  );

  const handleSearchInput = (e) => {
    const q = e.target.value;
    setCandidateList((prev) => ({ ...prev, currentPage: 1 }));
    setTitleValue(q);
    setDebouncedQuery(q); 
    setShowSuggestion(q.length > 0);
    handleSearchChange(q);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionsRef.current &&
        !suggestionsRef.current.contains(event.target)
      ) {
        setShowSuggestion(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   setTitleValue(query.get("occupational_classification"));
  //   setDebouncedQuery(query.get("occupational_classification") || "");
  // }, []);

  // useEffect(() => {

  //   fetchCandidatesList({
  //     limit,
  //     offset: (candidateList.currentPage - 1) * limit,
  //     q: debouncedQuery,
  //     filterValues: filterState,
  //     status_flag: false,
  //     is_generative: debouncedQuery ? true : false,
  //   });
  // }, [debouncedQuery]);
const hasFetched = useRef(false);

  useEffect(() => {
    const check =
      previousPathName &&
      previousPathName.pathname &&
      previousPathName.pathname.includes("/candidate-view");

    const filterValue =
      candidateFilter?.filter &&
      Object.keys(candidateFilter.filter).length > 0 &&
      Object.values(candidateFilter.filter).some((val) =>
        Array.isArray(val) ? val.length > 0 : val !== null,
      );

  const hasSearch = candidateFilter?.search && candidateFilter.search !== "";

  if (check) {
    if (filterValue) {
      setFilterState(candidateFilter.filter);
    }
    if (hasSearch) {
      setTitleValue(candidateFilter.search);
      setDebouncedQuery(candidateFilter.search);
    }
      setCandidateList((prev) => ({
        ...prev,
        currentPage: candidateFilter.pagination,
      }));
      if (candidateFilter.headerData?.length > 0) {
        setHeaderData(candidateFilter.headerData);
      }

    fetchCandidatesList({
      limit,
      offset: (candidateFilter.pagination - 1) * limit,
      q: candidateFilter.search || "",           // ← always pass search

      filterValues: candidateFilter.filter ?? filterState,
        direction: candidateFilter.direction || "desc",
        columnkey: candidateFilter.columnkey || "updated_at",
        status: candidateFilter.status ?? true,
      is_generative: hasSearch ? true : false,   // ← generative if search exists
    });

    hasFetched.current = true;
  } else if (!hasFetched.current) {
    hasFetched.current = true;

    if (query.get("occupational_classification")) {
      setTitleValue(query.get("occupational_classification"));
      setDebouncedQuery(query.get("occupational_classification"));
        fetchCandidatesList({
          limit,
          offset: 0,
          q: query.get("occupational_classification"),
          filterValues: filterState,
          is_generative: true,
        });
      } else {
        fetchCandidatesList({
          limit,
          offset: 0,
          q: "",
          filterValues: filterState,
          direction: "desc",
          columnkey: "updated_at",
          status: true,
        });
      }
    }
  }, [previousPathName]);

  const fetchJobTitles = async () => {
    try {
      const response = await AddToJobPoolList();
      const jobData = response.data;
      if (Array.isArray(jobData)) {
        const jobOptions = jobData.map((job) => ({
          label: `${job.unique_id} - ${job.title} - ${job.company}`,
          value: job.id,
        }));
        setJobTitles(jobOptions);
      } else {
        setJobTitles([]);
      }
    } catch (error) {
      setJobTitles([]);
    }
  };

  const handleApply = async (setFiles) => {
    try {
    const data = await checkBackGroundProcess(selectedJobTitle.value);
    if (data?.background_process_status === true) {
      setOpenActiveJobDialog(false); // close the add job pool dialog
      setBackGroundprocess({
        open: true,
        openLoading: false,
        buttonLoading: false,
      });
      return; // stop here
    }
  } catch (error) {
    setSnackbarState({
      open: true,
      severity: "error",
      message: error.message,
    });
    return;
  }
    setIsRunning(true);

    const existing = JSON.parse(localStorage.getItem("Add To Job Pool")) || [];
    const checkData = [...existing, ...checkSelected?.selected].map((item) => ({
      ...item,
      progress: 0,
      buffer: 0,
      visible: false,
      file: {
        ...item,
        progress: 0,
        buffer: 0,
        visible: false,
      },
      status: "Inprogress",
      job_id: selectedJobTitle.value,
    }));

    localStorage.setItem("Add To Job Pool", JSON.stringify(checkData));
    dispatch(
      AddToJobPoolBuffer({
        data: checkData,
      }),
    );

    setFiles((prev) => ({
      ...prev,
      file: prev.file.map((f) => ({
        ...f,
        progress: 0,
        buffer: 0,
        visible: false,
        message: "",
      })),
    }));
    const resumeIds = checkSelected?.selected?.map((item) => item.resume_id);
    // ?.map((item) => {
    //   const candidate = candidateList?.data?.find((c) => c.id === item.id);
    //   return candidate ? candidate?.resume_id : null;
    // })
    // .filter((id) => id !== null);

    try {
      const payload = {
        job: selectedJobTitle.value,
        resumes: resumeIds,
      };

      const response = await AddToJobPool(payload);
      const reader = response.body.getReader();
      const decoder = new TextDecoder("utf-8");
      let buffer = "";

      while (true) {
        const { value, done } = await reader.read();
        if (done) break;
        const chunk = decoder.decode(value, { stream: true });
        buffer += chunk;
        let boundaryIndex;
        while ((boundaryIndex = buffer.indexOf("}\n")) !== -1) {
          const jsonString = buffer.slice(0, boundaryIndex + 1);
          buffer = buffer.slice(boundaryIndex + 1);
          const jsonResponse = JSON.parse(jsonString);
          try {
            await processJsonResponse(jsonResponse, setFiles);
          } catch (e) {
            setFiles((prevFiles) => ({
              ...prevFiles,
              file: prevFiles.file.map((f) =>
                f.resume_id === jsonResponse.resume_id
                  ? {
                      ...f,
                      message: "Error during the request",
                      visible: true,
                    }
                  : { ...f },
              ),
            }));

            const existing =
              JSON.parse(localStorage.getItem("Add To Job Pool")) || [];
            const updatedData = existing.filter(
              (item) => item.resume_id !== jsonResponse.resume_id
            );
            localStorage.setItem(
              "Add To Job Pool",
              JSON.stringify(updatedData)
            );
            dispatch(
              AddToJobPoolBuffer({
                data: updatedData,
              })
            );

            setSnackbarState({
              open: true,
              message: "Error parsing JSON",
              severity: "error",
            });
            setIsRunning(false);
            setIsLoading(false);
          }
        }
      }

      if (buffer) {
        const jsonResponse = JSON.parse(buffer);
        try {
          await processJsonResponse(jsonResponse, setFiles);
        } catch (e) {
          setFiles((prevFiles) => ({
            ...prevFiles,
            file: prevFiles.file.map((f) =>
              f.resume_id === jsonResponse.resume_id
                ? {
                    ...f,
                    message: "Error during the request",
                    visible: true,
                  }
                : { ...f }
            ),
          }));
          const existing =
            JSON.parse(localStorage.getItem("Add To Job Pool")) || [];
          const updatedData = existing.filter(
            (item) => item.resume_id !== jsonResponse.resume_id
          );
          localStorage.setItem("Add To Job Pool", JSON.stringify(updatedData));
          dispatch(
            AddToJobPoolBuffer({
              data: updatedData,
            })
          );
          setSnackbarState({
            open: true,
            message: "Error parsing final JSON chunk",
            severity: "error",
          });
          setIsLoading(false);
          setIsRunning(false);
        }
      }
    } catch (error) {
      setFiles((prevFiles) =>
        prevFiles.file.map((f) => ({
          ...f,
          file: {
            ...f.file,
            message: "Error during the request",
            visible: true,
          },
        }))
      );

      setSnackbarState({
        open: true,
        message: "Error during the request",
        severity: "error",
      });

      const resumeIds =
        checkSelected?.selected?.map((item) => item.resume_id) || [];
      const filteredExisting = existing.filter(
        (item) => !resumeIds.includes(item.resume_id)
      );
      localStorage.setItem("Add To Job Pool", JSON.stringify(filteredExisting));

      dispatch(
        AddToJobPoolBuffer({
          data: filteredExisting,
        })
      );
      setIsLoading(false);
    }
    handleCloseActiveJobDialog();
  };

  const processJsonResponse = async (jsonResponse, setFiles) => {
    const { success, data, message, resume_id } = jsonResponse;
    if (Object.keys(data).length === 0) {
      const existing =
        JSON.parse(localStorage.getItem("Add To Job Pool")) || [];
      const resumeIds =
        checkSelected?.selected?.map((item) => item.resume_id) || [];
      const filteredExisting = existing.filter(
        (item) => !resumeIds.includes(item.resume_id)
      );
      localStorage.setItem("Add To Job Pool", JSON.stringify(filteredExisting));

      dispatch(
        AddToJobPoolBuffer({
          data: filteredExisting,
        })
      );
      setSnackbarState({
        open: true,
        message: message,
        severity: "error",
      });
    } else if (success && data?.percent !== undefined) {
      const existing =
        JSON.parse(localStorage.getItem("Add To Job Pool")) || [];

      setFiles((prevFiles) => ({
        ...prevFiles,
        file: prevFiles.file.map((f) =>
          f.resume_id === resume_id
            ? {
                ...f,
                progress: data.percent,
                buffer: data.percent,
                visible: false,
                progress_message: data.progress_message,
              }
            : f
        ),
      }));
      const updatedData = existing.map((item) =>
        item.resume_id === resume_id
          ? {
              ...item,
              progress: data.percent,
              buffer: data.percent,
              visible: false,
              progress_message: data.progress_message,
              file: {
                ...item.file,
                progress: data.percent,
                buffer: data.percent,
                visible: false,
                progress_message: data.progress_message,
              },
            }
          : item
      );

      localStorage.setItem("Add To Job Pool", JSON.stringify(updatedData));

      dispatch(
        AddToJobPoolBuffer({
          data: updatedData,
        })
      );
    } else if (data?.length !== 0 && data?.[0]?.id) {
      const existing =
        JSON.parse(localStorage.getItem("Add To Job Pool")) || [];
      const updatedData = existing.filter(
        (item) => item.file?.progress !== 100
      );

      localStorage.setItem("Add To Job Pool", JSON.stringify(updatedData));

      dispatch(
        AddToJobPoolBuffer({
          data: updatedData,
        })
      );
    } else if (!success) {
      setFiles((prevFiles) => ({
        ...prevFiles,
        file: prevFiles.file.map((f) =>
          f.resume_id === resume_id || data.length === 0
            ? { ...f, visible: true, message: message }
            : { ...f, delete: true }
        ),
      }));
      const existing =
        JSON.parse(localStorage.getItem("Add To Job Pool")) || [];
      const updatedData = existing.filter(
        (item) => item.resume_id !== resume_id
      );
      localStorage.setItem("Add To Job Pool", JSON.stringify(updatedData));
      dispatch(
        AddToJobPoolBuffer({
          data: updatedData,
        })
      );
      setIsLoading(false);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleClose = () => {
    setFilterPopup(false);
  };

  const handleOpenActiveJobDialog = () => {
    setOpenActiveJobDialog(true);
    handleMenuClose();
    setFiles((prev) => ({
      ...prev,
      file: checkSelected.selected,
      progress: 0,
      buffer: 0,
      visible: false,
      message: "",
    }));
    fetchJobTitles();
  };

const handlebackGroundWarningClose = () => {
  setBackGroundprocess({
    open: false,
    openLoading: false,
    buttonLoading: false,
  });
};

const handlebackGroundWarning = () => {
  setBackGroundprocess((prev) => ({ ...prev, buttonLoading: true }));
  setTimeout(() => {
    handlebackGroundWarningClose();
  }, 1000);
};

const BackGroundFooter = () => (
  <CommonGrid2 display={"flex"} gap={"1rem"}>
    <CommonButton
      value={"OK"}
      width={"100%"}
      padding={"10px"}
      marginTop={"2rem"}
      fontWeight={"700"}
      fontSize={"15px"}
      onClick={handlebackGroundWarning}
      disabled={backGroundprocess.buttonLoading}
      loading={backGroundprocess.buttonLoading}
    />
  </CommonGrid2>
);

  const handleCloseActiveJobDialog = () => {
    setOpenActiveJobDialog(false);
    setIsRunning(false);
    setFiles({ file: [] });
    setCheckSelected({
      selected: [],
      count: 0,
    });
  };

  const handleSuggestionClick = (suggestion) => {
    setTitleValue(suggestion);
    setDebouncedQuery(suggestion);
    setShowSuggestion(false);
  };

  const handleDelete = () => {
    handleMenuClose();
    setDeleteDialog((prev) => ({
      ...prev,
      open: true,
      content: tableRowData,
    }));
  };

  const handleIconClick = (event, rowData) => {
    setTableRowData(rowData);
    setAnchorEl(event.currentTarget);
  };

  const handleClick = () => {
    fetchCandidatesList({
      limit,
      offset: (candidateList.currentPage - 1) * limit,
      q: currentQuery,
      filterValues: filterState || {},
      status_flag: true,
    });
    setShowSuggestion(false);
  };

  const handleSingleSelect = (row) => {
    setCheckSelected((prev) => {
      const isSelected = prev.selected.some((item) => item.id === row.id);
      const updatedSelected = isSelected
        ? prev.selected.filter((item) => item.id !== row.id)
        : [
            ...prev.selected,
            {
              id: row.id,
              name: row.name,
              type: row.resume_file_name,
              resume_id: row.resume_id,
            },
          ];

      const updatedCount = updatedSelected.length;

      return { selected: updatedSelected, count: updatedCount };
    });
  };

  const handleSelectAll = () => {
    const allIds = candidateList.data.map((row) => ({
      id: row.id,
      name: row.name,
      type: row.resume_file_name,
      resume_id: row.resume_id,
    }));
    const jobPoolIds = addToJobPoolData?.data?.map((item) => item.id) || [];
    const selectableIds = allIds.filter((row) => !jobPoolIds.includes(row.id));

    if (
      selectableIds.every(
        (row) => checkSelected.selected.some((item) => item.id === row.id)

        // candidateList.data.every((row) =>
        //   checkSelected.selected.some((item) => item.id === row.id)
      )
    ) {
      const deselectedIds = checkSelected.selected.filter(
        (item) => !selectableIds.some((row) => row.id === item.id)
      );
      setCheckSelected({
        selected: deselectedIds,
        count: deselectedIds.length,
      });
    } else {
      const updatedSelected = [...checkSelected.selected, ...selectableIds];
      const uniqueSelected = Array.from(
        new Set(updatedSelected.map((item) => item.id))
      ).map((id) => updatedSelected.find((item) => item.id === id));

      setCheckSelected({
        selected: uniqueSelected,
        count: uniqueSelected.length,
      });
    }
  };

  const handleSort = (columnName) => {
    setHeaderData((prevHeaderData) =>
      prevHeaderData.map((col) => {
        if (col.name === columnName.name) {
          return {
            ...col,
            active: true,
            direction: col.direction === "asc" ? "desc" : "asc",
          };
        }
        if (col.sort) {
          return {
            ...col,
            active: false,
            direction: col.defaultDirection,
          };
        }

        return col;
      })
    );
    setCandidateList((prev) => {
      return {
        ...prev,
        columnName: columnName.name,
        columnkey: columnName.key,
        status: true,
        direction: columnName.direction === "asc" ? "desc" : "asc",
      };
    });

    fetchCandidatesList({
      limit,
      offset: (candidateList.currentPage - 1) * limit,
      q: debouncedQuery,
      filterValues: filterState,
      status_flag: false,
      columnkey: columnName.key,
      status: true,
      direction: columnName.direction === "asc" ? "desc" : "asc",
    });
  };
  const isAddToJobPoolEnabled = checkSelected.count > 0;

  const handleDeleteChip = (key, item) => {
    const newState = {
      ...filterState,
      [key]: filterState[key].filter((chip) => chip !== item),
    };
    setCandidateList((prev) => ({
      ...prev,
      currentPage: 1,
    }));

    setFilterState(newState);
    fetchCandidatesList({
      limit,
      offset: 0,
      q: candidateList.search,
      filterValues: newState,
    });
  };

  const handleDropdownChange = (key, value) => {
    const newState = { ...filterState, [key]: value };
    setFilterState(newState);
    fetchCandidatesList({
      limit,
      offset: (candidateList.currentPage - 1) * limit,
      q: currentQuery,
      filterValues: newState,
      status_flag: false,
    });
  };

  const countSelectedFields = () => {
    return Object.values(filterState).filter((value) =>
      Array.isArray(value) ? value.length > 0 : value != null
    ).length;
  };

  const selectedCount = countSelectedFields();

  const getTotalSelectedCount = () => {
    let count = 0;

    Object.values(filterState).forEach((value) => {
      if (Array.isArray(value)) {
        count += value.length;
      } else if (value !== null && value !== undefined && value !== "") {
        count += 1;
      }
    });

    return count;
  };
  const totalCount = getTotalSelectedCount();

  const handleDateChange = (key, start, end) => {
    const newState = {
      ...filterState,
      [key]: {
        from_date: start,
        to_date: end || start,
      },
    };
    setFilterState(newState);
    fetchCandidatesList({
      limit,
      offset: (candidateList.currentPage - 1) * limit,
      q: currentQuery,
      filterValues: newState,
      status_flag: false,
    });
  };
  const handleApplyFilters = () => {
    setButtonLoading({
      loading: true,
      disabled: true,
    });
    fetchCandidatesList({ filterValues: filterState }).finally(() => {
      handleClose();
      setButtonLoading({
        loading: false,
        disabled: false,
      });
    });
    dispatch(
      CandidateFilter({
        filter: filterState,
        search: titleValue,
        pagination: candidateList.currentPage,
        headerData: headerData,
        columnkey: candidateList.columnkey,
        direction: candidateList.direction,
        status: candidateList.status,
      }),
    );
  };

  const handleClearForm = () => {
    setFilterState(
      filterOptions.reduce((acc, option) => {
        acc[option.key] = option.type === "multi-select" ? [] : null;
        return acc;
      }, {})
    );
  };

  const handleFocus = () => {
    setShowSuggestion(true);
  };

  const handleChangeStatus = async (e, row) => {
    e.stopPropagation();
    setStatusDialog((prev) => ({
      ...prev,
      open: true,
      value: e.target.value,
      id: row,
    }));
  };

  const handleStatusClose = () => {
    setStatusDialog({
      open: false,
      disabled: false,
      noLoading: false,
      yesLoading: false,
      value: "",
      id: "",
    });
    setCheckSelected({
      selected: [],
      count: 0,
    });
  };

  const handleCheckInterestStatusClose = () => {
    setCheckInterestStatusDialog({
      open: false,
      disabled: false,
      noLoading: false,
      yesLoading: false,
    });
    setCheckSelected({
      selected: [],
      count: 0,
    });
  };

  const handleStatusChange = async (condition) => {
    if (condition === "no") {
      setStatusDialog((prev) => ({
        ...prev,
        noLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        handleStatusClose();
      }, 1000);
    } else if (condition === "yes") {
      setStatusDialog((prev) => ({
        ...prev,
        yesLoading: true,
        disabled: true,
      }));
      try {
        let payload = {
          status: statusDialog.value,
          id: statusDialog.id?.resume_id,
        };
        const data = await CandidateStatusChange(payload);
        setSnackbarState({
          open: true,
          severity: "success",
          message: data.message,
        });
        handleStatusClose();
        await fetchCandidatesList({
          limit,
          offset: (candidateList.currentPage - 1) * limit,
        });
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error.message,
        });
        setStatusDialog((prev) => ({
          ...prev,
          yesLoading: false,
          disabled: false,
        }));
      }
    } else if (condition === "check-interest-no") {
      setCheckInterestStatusDialog((prev) => ({
        ...prev,
        noLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        handleCheckInterestStatusClose();
      }, 1000);
    } else if (condition === "check-interest-yes") {
      setCheckInterestStatusDialog((prev) => ({
        ...prev,
        yesLoading: true,
        disabled: true,
      }));
      try {
        let data = checkSelected.selected.map((item) => {
          return {
            url: `${url}/candidate-coversheet?id=${item.resume_id}&name=${
              item.name
            }&org_logo_url=${encodeURIComponent(
              localStorageData?.org_logo_url
            )}&organization=${localStorageData?.org_label}`,
            resume_id: item.resume_id,
          };
        });
        let payload = data;
        const response = await SendInterest(payload);
        handleCheckInterestStatusClose();
        setSnackbarState({
          open: true,
          message: response.message || "Request successful!",
          severity: "success",
        });
        await fetchCandidatesList({
          limit,
          offset: (candidateList.currentPage - 1) * limit,
        });
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error.message,
        });
        setCheckInterestStatusDialog((prev) => ({
          ...prev,
          yesLoading: false,
          disabled: false,
        }));
      }
    }
  };

  const SatusFooter = () => (
    <CommonGrid2 display={"flex"} gap={"1rem"}>
      <CommonButton
        value={"No"}
        variant="outlined"
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        color="#344054"
        border="#D0D5DD"
        disabled={statusDialog.disabled || checkInterestStatusDialog.disabled}
        loading={statusDialog.noLoading || checkInterestStatusDialog.noLoading}
        onClick={() =>
          handleStatusChange(statusDialog.open ? "no" : "check-interest-no")
        }
      />
      <CommonButton
        value={"Yes"}
        width={"100%"}
        padding={"10px"}
        marginTop={"2rem"}
        fontWeight={"700"}
        fontSize={"15px"}
        disabled={statusDialog.disabled || checkInterestStatusDialog.disabled}
        loading={
          statusDialog.yesLoading || checkInterestStatusDialog.yesLoading
        }
        onClick={() =>
          handleStatusChange(statusDialog.open ? "yes" : "check-interest-yes")
        }
      />
    </CommonGrid2>
  );

  const handleCustomCheckBox = (checkSelected, row) => {
    const dataFilter = addToJobPoolData?.data?.find(
      (item) => item.id === row.id
    );
    const showProgress = Boolean(dataFilter);

    return (
      <Fragment>
        {showProgress ? (
          <CustomTooltip
            arrow
            title={row?.progress_message}
            placement="top"
            fontWeight="600"
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <Gauge
                width={55}
                height={55}
                value={dataFilter.file.progress}
                valueMax={100}
                cornerRadius="30%"
                outerRadius="100%"
                innerRadius="75%"
                text={({ value, valueMax }) => `${dataFilter.file.progress}%`}
                sx={(theme) => ({
                  [`& .${gaugeClasses.valueText}`]: {
                    fontSize: 10,
                    color: "#101828",
                    fontWeight: 600,
                  },
                  [`& .${gaugeClasses.valueArc}`]: {
                    fill: "rgb(105, 65, 198)",
                  },
                })}
              />
            </Box>
          </CustomTooltip>
        ) : (
          <Checkbox
            color="primary"
            checked={checkSelected.some((item) => item.id === row.id)}
            onChange={() => {
              handleSingleSelect(row);
            }}
            // disabled={["Unavailable", "Do Not Hire"].includes(row.status)}
          />
        )}
      </Fragment>
    );
  };

  const handleTableBodyData = (row) => {
    return (
      <>
        <TableCell>{row.id}</TableCell>
        <TableCell>{row.name}</TableCell>
        <TableCell>{row.job_title}</TableCell>
        <TableCell>
          <CustomDiv
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <DropDownSelect
              marginTop="0px"
              removeAnimation={true}
              data={handleStatusOptions(row.status)}
              valueChange={true}
              fullWidth={false}
              title={"Select Status"}
              CustomMenuItem={CustomizeMenuItem}
              handleRenderValue={(selected) => {
                const selectedOption = statusOptions.find(
                  (option) => option.id === selected
                );
                return (
                  <Box display={"flex"} alignItems={"center"}>
                    <DotColor color={selectedOption?.color} marginRight="8px" />
                    <Typography>{selectedOption?.name}</Typography>
                  </Box>
                );
              }}
              customStyle={{
                "& .MuiSelect-select": {
                  padding: "4px 32px 4px 10px !important",
                  borderRadius: "6px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  borderColor: () => {
                    let color;
                    if (row.status === "Active") {
                      color = "#17B26A";
                    } else if (row.status === "Hold") {
                      color = "orange";
                    } else if (row.status === "Filled") {
                      color = "#9E77ED";
                    } else if (row.status === "Draft") {
                      color = "#667085";
                    } else {
                      color = "#F04438";
                    }
                    return color;
                  },
                  boxShadow: "0px 0px 1px 0px #101828",
                  borderWidth: "1px",
                },
                "& .MuiSelect-icon": {
                  right: "0rem",
                },
              }}
              width={"115px"}
              maxHeight={"215px"}
              value={row.status}
              handleChange={(e) => handleChangeStatus(e, row)}
            />
          </CustomDiv>
        </TableCell>
        <TableCell>
          <ScoreChange>{row.rice_score}%</ScoreChange>
        </TableCell>
        <TableCell>{row.updated_at}</TableCell>
        <TableCell>
          <CustomDiv onClick={(e) => e.stopPropagation()}>
            <MoreVertOutlinedIcon
              style={{ cursor: "pointer" }}
              onClick={(e) => handleIconClick(e, row)}
            />
            <CustomMenuItem
              open={open}
              anchorEl={anchorEl}
              handleMenuClose={handleMenuClose}
              menuData={menuData}
              boxShadow={
                "0px 0px 0px 0px rgba(16, 24, 40, 0.08),0px 3px 5px -3px rgba(16, 24, 40, 0.03)"
              }
            />
          </CustomDiv>
        </TableCell>
      </>
    );
  };

  const saveFilterToRedux = () => {
    dispatch(
      CandidateFilter({
        filter: filterState,
        search: titleValue,
        pagination: candidateList.currentPage,
        headerData: headerData,
        columnkey: candidateList.columnkey,
        direction: candidateList.direction,
        status: candidateList.status,
      })
    );
  };

const handleRowClick = (row) => {
  saveFilterToRedux();
  navigate(`/candidates/candidate-view?view-id=${row.resume_id}`);
};

  const handleDeleteClose = () => {
    setDeleteDialog((prev) => ({
      ...prev,
      open: false,
      loading: false,
    }));
  };

  const handleDeleteRow = async () => {
    setDeleteDialog((prev) => ({
      ...prev,
      loading: true,
    }));
    let payload = {
      is_draft: false,
    };
    try {
      let data = await CandidateDelete(
        deleteDialog.content?.resume_id,
        payload
      );
      let page =
        candidateList.currentPage === 1
          ? 1
          : candidateList.data?.length === 1
          ? candidateList.currentPage - 1
          : candidateList.currentPage;
      setCandidateList((prev) => ({
        ...prev,
        currentPage: page,
      }));
      fetchCandidatesList({
        limit,
        offset: (page - 1) * limit,
        filterValues: filterState,
      });
      setDeleteDialog((prev) => ({
        ...prev,
        open: false,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        message: data?.message,
        severity: "success",
      });
    } catch (error) {
      setDeleteDialog((prev) => ({
        ...prev,
        loading: false,
      }));
      setSnackbarState({
        open: true,
        severity: "error",
        message: error?.data?.message,
      });
    }
  };

  const handleShareDialogClose = () => {
    setShareDialogOpen({ open: false, loading: false, multiEmail: false });
    setCheckSelected({
      selected: [],
      count: 0,
    });
  };

  const handleShareInvite = async (shareData) => {
    setShareDialogOpen((prev) => ({
      ...prev,
      loading: true,
    }));
    try {
      let payload;
      if (shareDialogOpen.multiEmail) {
        payload = {
          url: `${URL}/candidates/candidate-view?view-id=`,
          to_mail: shareData.map((item) => item.email),
          resumes: checkSelected.selected.map((item) => item.resume_id),
        };
      } else {
        payload = {
          url: `${URL}/candidates/candidate-view?view-id=${tableRowData.resume_id}`,
          to_mail: shareData.map((item) => item.email),
        };
      }

      const data = shareDialogOpen.multiEmail
        ? await CandidateMultiEmail(payload)
        : await ResumeShare(tableRowData.resume_id, payload);
      setSnackbarState({
        open: true,
        message: data.message,
        severity: "success",
      });
      setCheckSelected({
        selected: [],
        count: 0,
      });
      handleShareDialogClose();
    } catch (error) {
      setSnackbarState({
        open: true,
        message: error.message,
        severity: "error",
      });
      setShareDialogOpen((prev) => ({
        ...prev,
        loading: false,
      }));
    }
  };

  const handleShareClick = () => {
    handleMenuClose();
    setShareDialogOpen({ open: true, loading: false, multiEmail: false });
  };

  const menuData = [
    {
      title: "Share",
      image: <ShareIco />,
      onClick: handleShareClick,
    },
    {
      title: "Add to an Active Job",
      image: <FileAddIco />,
      disabled: true,
      onClick: handleOpenActiveJobDialog,
    },
    {
      title: "View",
      image: <EyeIco />,
     onClick: () => {
  saveFilterToRedux();
  navigate(`/candidates/candidate-view?view-id=${tableRowData.resume_id}`);
},
    },
    {
      title: "Delete",
      image: <DeleteIco />,
      onClick: handleDelete,
    },
  ];

  const handleChangeStatusBtn = async (condition) => {
    if (condition === "change-status") {
      setSelectDialog((prev) => ({
        ...prev,
        changeStatusLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        setSelectDialog((prev) => ({
          ...prev,
          disabled: false,
          condition: false,
        }));
      }, 1000);
    } else if (condition === "no") {
      setSelectDialog((prev) => ({
        ...prev,
        noLoading: true,
        disabled: true,
      }));
      setTimeout(() => {
        handleChangeStatusClose();
      }, 1000);
    } else if (condition === "change") {
      setSelectDialog((prev) => ({
        ...prev,
        changeLoading: true,
        disabled: true,
      }));
      try {
        let payload = {
          jobs: checkSelected.selected.map((item) => item.id),
        };

        let params = {
          status: selectDialog.value,
        };

        handleChangeStatusClose();
        fetchCandidatesList({
          limit,
          offset: (candidateList.currentPage - 1) * limit,
        });
      } catch (error) {
        setSnackbarState({
          open: true,
          severity: "error",
          message: error.message,
        });
        setSelectDialog((prev) => ({
          ...prev,
          changeLoading: false,
          disabled: false,
        }));
      }
    }
  };

  const ChangeStatusFooter = () => (
    <>
      {selectDialog.condition ? (
        <CommonButton
          value={"Change Status"}
          width={"100%"}
          padding={"10px"}
          marginTop={"2rem"}
          fontWeight={"700"}
          fontSize={"15px"}
          disabled={selectDialog.disabled}
          loading={selectDialog.changeStatusLoading}
          onClick={() => handleChangeStatusBtn("change-status")}
        />
      ) : (
        <CommonGrid2 display={"flex"} gap={"1rem"}>
          <CommonButton
            value={"No"}
            variant="outlined"
            width={"100%"}
            padding={"10px"}
            marginTop={"2rem"}
            fontWeight={"700"}
            fontSize={"15px"}
            color="#344054"
            border="#D0D5DD"
            disabled={selectDialog.disabled}
            loading={selectDialog.noLoading}
            onClick={() => handleChangeStatusBtn("no")}
          />
          <CommonButton
            value={"Yes"}
            width={"100%"}
            padding={"10px"}
            marginTop={"2rem"}
            fontWeight={"700"}
            fontSize={"15px"}
            disabled={selectDialog.disabled}
            loading={selectDialog.changeLoading}
            onClick={() => handleChangeStatusBtn("change")}
          />
        </CommonGrid2>
      )}
    </>
  );

  const handleChangeStatusClose = () => {
    setSelectDialog({
      open: false,
      disabled: false,
      changeStatusLoading: false,
      cancelLoading: false,
      changeLoading: false,
      value: "Active",
      id: "",
      condition: true,
    });

    setCheckSelected({
      selected: [],
      count: 0,
    });
  };

  const CustomizeMenuItem = (item, index) => (
    <MenuItem key={index} value={item.id}>
      {item.name}
    </MenuItem>
  );

  const handleContent = () => (
    <>
      {selectDialog.condition ? (
        <CommonGrid2
          display={"flex"}
          flexDirection={"column"}
          gap={"0.8rem"}
          textAlign={"left"}
          marginTop={"1rem"}
        >
          <Typography variant="h6" fontWeight={500}>
            Status
          </Typography>
          <DropDownSelect
            marginTop="0px"
            removeAnimation={true}
            data={handleStatusOptions(selectDialog.value)}
            value={selectDialog.value}
            valueChange={true}
            id={"change_status"}
            CustomMenuItem={CustomizeMenuItem}
            handleChange={(e) =>
              setSelectDialog((prev) => ({
                ...prev,
                value: e.target.value,
              }))
            }
          />
        </CommonGrid2>
      ) : (
        <CommonGrid2
          display={"flex"}
          textAlign={"start"}
          gap={"0.5rem"}
          flexDirection={"column"}
          marginTop={"1rem"}
        >
          <Typography variant="h5">Change Status?</Typography>
          <Typography variant="p">
            {" "}
            Do you want to Change the status{" "}
            {checkSelected.count === 1 && (
              <CustomizeSpan>
                from{" "}
                <CustomizeSpan fontWeight={700}>
                  {checkSelected.selected[0]?.status}
                </CustomizeSpan>
              </CustomizeSpan>
            )}{" "}
            to{" "}
            <CustomizeSpan fontWeight={700}>
              {selectDialog.value} ?
            </CustomizeSpan>
          </Typography>
        </CommonGrid2>
      )}
    </>
  );

  const statusOptions = [
    { name: "Active", color: "#17B26A", id: "Active" },
    { name: "Unavailable", color: "#9E77ED", id: "Unavailable" },
    { name: "Inactive", color: "#667085", id: "Inactive" },
    { name: "Do Not Hire", color: "#F04438", id: "Do Not Hire" },
  ];

  const handleStatusOptions = (rowStatus) => {
    const options = [
      { name: "Active", color: "#17B26A", id: "Active" },
      { name: "Unavailable", color: "#9E77ED", id: "Unavailable" },
      { name: "Inactive", color: "#667085", id: "Inactive" },
      { name: "Do Not Hire", color: "#F04438", id: "Do Not Hire" },
    ];
    // if (rowStatus === "Unavailable") {
    //   return options.filter((option) => option.id === "Unavailable");
    // } else if (rowStatus === "Do Not Hire") {
    //   return options.filter((option) => option.id === "Do Not Hire");
    // }

    return options;
  };

  const handleMultiStatusChange = () => {
    setSelectDialog((prev) => ({
      ...prev,
      open: true,
      value:
        checkSelected.count === 1
          ? checkSelected.selected[0]?.status
          : "Active",
    }));
  };

  const handleCheckInterestOpen = () => {
    setCheckInterestStatusDialog((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const buttonCard = [
    {
    title: "Add to Job Pool",
    onClick: handleOpenActiveJobDialog,
    disabled: !isAddToJobPoolEnabled ,
    
    },
    {
      title: "Change Status",
      onClick: handleMultiStatusChange,
      disabled: !isAddToJobPoolEnabled || true,
    },
    {
      title: "Check Interest",
      onClick: handleCheckInterestOpen,
      disabled: !isAddToJobPoolEnabled,
    },
    {
      title: "Share HotList",
      onClick: () =>
        setShareDialogOpen((prev) => ({
          ...prev,
          multiEmail: true,
          open: true,
        })),
      disabled: !isAddToJobPoolEnabled,
    },
  ];

  return (
    <CustomDiv
      margin={"1rem 1rem 1rem 1.5rem"}
      padding={"1rem"}
      borderRadius={"10px"}
      background="#fff"
      border={"1px solid rgba(0, 0, 0, 0.12)"}
    >
      <Grid2 container alignItems="center" justifyContent={"space-between"}>
        <Grid2 item size={5} display="flex" alignItems="center">
          <Typography variant="h2">Candidates</Typography>
        </Grid2>
        <CommonGrid2
          item
          size={6}
          display="flex"
          alignItems="center"
          gap={"1rem"}
          position={"relative"}
        >
          <CommonTextField
            placeholder="Search for candidate name and title..."
            placeholderFontSize="14px"
            startIcon={<SearchIcon />}
            value={titleValue}
            onChange={handleSearchInput}
            handleFocus={handleFocus}
          />
          {showSuggestion && suggestion.length > 0 && (
            <List
              ref={suggestionsRef}
              sx={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                background: "white",
                border: "1px solid #ccc",
                borderRadius: 1,
                zIndex: 1000,
                maxHeight: 200,
                overflowY: "auto",
                fontFamily: "Inter",
              }}
            >
              {suggestion.map((sug, index) => (
                <ListItem
                  key={index}
                  button
                  onClick={() => handleSuggestionClick(sug)}
                  sx={{
                    padding: "8px 16px",
                    cursor: "pointer",
                    fontFamily: "Inter",
                    "&:hover": {
                      backgroundColor: "#f5f5f5",
                    },
                  }}
                >
                  {sug}
                </ListItem>
              ))}
            </List>
          )}
          <Badge badgeContent={totalCount} color="primary">
            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              value="Filters"
              onClick={() => setFilterPopup(true)}
              disabled={candidateList.loading}
            />
          </Badge>
          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="600"
            value="Add New"
            onClick={() =>
              navigate("/resume-intelligence/create-candidate-resume")
            }
          />
        </CommonGrid2>
      </Grid2>
      <StyledFlexRowView
        style={{ justifyContent: "space-between", padding: "32px 0px 0px 0px" }}
      >
        <CheckBoxSelected>
          Selected{" "}
          <span style={{ color: "#667085" }}> · {checkSelected.count}</span>
        </CheckBoxSelected>
        <ButtonGroup variant="outlined" aria-label="Basic button group">
          {buttonCard.map((item, index) => (
            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              value={item.title}
              padding={"10px 16px"}
              disabled={item.disabled}
              loading={item.loading}
              onClick={item.onClick}
              
            />
          ))}
        </ButtonGroup>
      </StyledFlexRowView>
      {selectedCount !== 0 && (
        <CommonGrid2
          size={12}
          display="flex"
          alignItems="center"
          marginTop={"1.5rem"}
          gap={"0.5rem"}
          flexWrap={"wrap"}
        >
          <Typography variant="h3">Filter : </Typography>
          {Object.keys(filterState).map((filterKey) => {
            const value = filterState[filterKey];
            if (!Array.isArray(value)) return null;
            return value.map((item, index) => (
              <CustomizeChip
                key={index}
                label={`${filterKey} - ${item}`}
                onDelete={() => handleDeleteChip(filterKey, item)}
              />
            ));
          })}
        </CommonGrid2>
      )}

      {correctedQuery && (
        <CheckBoxSelected style={{ padding: "16px 0px 0px 0px" }}>
          <span style={{ color: "#000" }}>{"These are results for "}</span>
          <span style={{ color: "#7f56d9" }}>{correctedQuery}</span>
        </CheckBoxSelected>
      )}
      {currentQuery && correctedQuery !== null && (
        <CheckBoxSelected
          style={{ padding: "0px 0px 0px 0px", fontSize: "14px" }}
        >
          <span style={{ color: "#000" }}>{"Search instead for "}</span>
          <button
            style={{
              color: "#7f56d9",
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "inherit",
              textDecoration: "underline",
            }}
            onClick={() => handleClick()}
          >
            {currentQuery}
          </button>
        </CheckBoxSelected>
      )}

      <CommonTable
        data={candidateList.data}
        columns={headerData}
        onSortChange={handleSort}
        checkSelected={checkSelected.selected}
        handleCustomCheckBox={handleCustomCheckBox}
        handleTableBodyData={handleTableBodyData}
        paginationProps={{
          count: candidateList.totalPage,
          page: candidateList.currentPage,
          onPageChange: (page) => {
            setCandidateList((prev) => ({
              ...prev,
              currentPage: page,
            }));
            fetchCandidatesList({
              limit,
              offset: (page - 1) * limit,
              filterValues: filterState,
            });
          },
        }}
        withPagination={true}
        withCheckbox={true}
        loading={candidateList.loading}
        handleSingleSelect={handleSingleSelect}
        handleSelectAll={handleSelectAll}
        sort={candidateList}
        customStyle={{
          "& .MuiTableRow-root": {
            cursor: "pointer",
          },
          "& .MuiTableRow-head": {
            cursor: "auto",
          },
        }}
        textAlign="center"
        handleRowClick={handleRowClick}
      />
      <FilterDialog
        open={filterPopup}
        onClose={handleClose}
        title="Filter"
        filterOptions={filterOptions}
        backgroundImage="path_to_background_image"
        count={candidateList.count}
        filterState={filterState}
        handleClearForm={handleClearForm}
        handleDropdownChange={handleDropdownChange}
        handleDateChange={handleDateChange}
        handleApplyFilters={handleApplyFilters}
        selectedCount={selectedCount}
        buttonLoading={buttonLoading}
      />

      <AddJobPool
        open={openActiveJobDialog}
        onClose={handleCloseActiveJobDialog}
        activeOptions={activeJobData}
        onApply={() => handleApply(setFiles)}
        placeholder="Search for Job or Company"
        buttonValue="Add and Score"
        disabled={!selectedJobTitle || isLoading || isRunning}
        loading={isRunning}
        files={files}
        isLoading={jobTitles.length == 0}
        backgroundImage="path_to_background_image"
      />

      <ShareQuickMatch
        title="Share Candidate Profile"
        shareDialogOpen={shareDialogOpen.open}
        handleShareDialogClose={handleShareDialogClose}
        handleShareInvite={handleShareInvite}
        isLoading={shareDialogOpen.loading}
      />

      <SkillDeleteDialog
        deleteDialog={deleteDialog.open}
        handleDeleteDialogClose={handleDeleteClose}
        handleDeleteSkill={handleDeleteRow}
        buttonLoading={deleteDialog.loading}
        title={"Delete Candidate"}
        content={deleteDialog.content?.name}
      />

      <SnackBar
        snackbarState={snackbarState}
        handleCloseValidation={handleCloseValidation}
      />
      <DialogCandidateHub
          open={backGroundprocess.open}
          title="Processing"
          titlepadding={"0px 0px 16px"}
          handleClose={handlebackGroundWarningClose}
          footer={<BackGroundFooter />}
          content={
            "A background process is in progress. Please wait a few minutes while it completes."
          }
        />

      <DialogCandidateHub
        open={selectDialog.open}
        handleButttonClose={handleChangeStatusClose}
        icon={<StatusChangeIco margin={"10px 0px 0px 10px"} />}
        footer={<ChangeStatusFooter />}
        title={
          checkSelected.count === 1 && checkSelected.selected[0]?.job_title
        }
        titlepadding={"0rem 0px 0px"}
        content={handleContent()}
      />

      <DialogCandidateHub
        open={statusDialog.open}
        handleButttonClose={handleStatusClose}
        footer={<SatusFooter />}
        title={"Do you want to confirm this"}
        titlepadding={"1rem 0px 0px"}
      />
      <DialogCandidateHub
        open={checkInterestStatusDialog.open}
        handleButttonClose={handleCheckInterestStatusClose}
        footer={<SatusFooter />}
        title={
          "Do you want to send interest check emails to the selected candidates?"
        }
        titlepadding={"0px 0px 0px"}
      />
    </CustomDiv>
  );
}
